import React, { CSSProperties, ReactNode } from 'react';

import { AutoTextSize } from 'auto-text-size';
import { useTheme } from 'styled-components';
import { useMeasuredFontSize } from '../hooks/useMeasuredFontSize';

export interface ResponsiveTextProps {
    children?: ReactNode;
    max?: number;
    min?: number;
    color?: string;
    weight?: number | string;
    style?: CSSProperties;
    isLoading?: boolean;
    skeleton?: ReactNode;
    onFontSizeChange?: (size: number) => void;
    className?: string;
    [key: string]: any;
}

export function ResponsiveText({
    children,
    max = 28,
    min = 12,
    color = '#2081ff',
    weight = 600,
    style = {},
    isLoading = false,
    onFontSizeChange,
    skeleton = null,
    className,
    ...rest
}: ResponsiveTextProps) {
    const { ref, fontSize } = useMeasuredFontSize();

    const { theme, colors } = useTheme();

    React.useEffect(() => {
        if (fontSize && onFontSizeChange) {
            onFontSizeChange(fontSize);
        }
    }, [fontSize]);

    return (
        <div
            ref={ref}
            style={{ display: 'inline-block', width: 'calc(100% - 10px)' }}
        >
            <AutoTextSize
                mode="oneline"
                maxFontSizePx={max}
                minFontSizePx={min}
                className={className}
                {...rest}
                style={{
                    margin: 'auto',
                    fontWeight: weight,
                    color,
                    ...style,
                }}
            >
                {!isLoading ? children : skeleton}
            </AutoTextSize>
        </div>
    );
}
